import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import {
  getTotalFormatted,
  getItemTitle,
  getItemDescription,
  getItemPrice,
} from '../../Reducers/Configurator/Selectors';
import { Toolbar } from '../Toolbar/Toolbar';
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import { green } from '../../Constants/Colors';
import { toggleOverviewSidebar } from '../../Reducers/UI/Actions';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import InfoIcon from '../../Resources/Images/icon-info-2-green.svg';
import AdditionalInfoDialog from '../AdditionalInfoDialog/AdditionalInfoDialog';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerTitle: {
      fontFamily: 'Inter',
      fontWeight: 400,
      paddingLeft: '5px',
      paddingRight: '10px',
    },
    configurationPriceLabel: {
      fontFamily: 'Inter',
      fontWeight: 600,
      color: green,
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 'auto',
      },
    },
    iconContainer: {
      minWidth: '40px',
      width: '40px',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      width: '70%',
    },
    titleInfoContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: 12,
    },
    languageSwitchContainer: {
      marginLeft: '30px',
    },
    title: {
      fontFamily: 'Inter',
    },
    menuIcon: {
      paddingLeft: '0px !important',
      paddingRight: '0px !important',
    },
  }),
  {
    name: 'Header',
  }
);

const Header = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isAdditionalInfoPopupOpen, setIsAdditionalInfoPopupOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const totalFormatted = useSelector(getTotalFormatted);
  const itemTitle = useSelector(getItemTitle);
  const itemDescription = useSelector(getItemDescription);
  const itemPrice = useSelector(getItemPrice);

  const menuVisible = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.container}>
      {isMobile && (
        <div className={classes.titleInfoContainer}>
          <Typography variant="h5" color="inherit" className={classes.title}>
            {itemTitle}
          </Typography>
          <div className={classes.iconContainer} onClick={() => setIsAdditionalInfoPopupOpen(true)}>
            <img className={classes.icon} src={InfoIcon} />
          </div>
        </div>
      )}
      {!isMobile && (
        <>
          <Toolbar loadEnabled={true} />
          <Typography variant="body1" className={classes.headerTitle}>
            {t('general.yourConfiguration')}
          </Typography>
        </>
      )}
      <Typography
        onClick={() => dispatch(toggleOverviewSidebar())}
        variant="body1"
        className={classes.configurationPriceLabel}
      >
        {totalFormatted + '*'}
      </Typography>
      <div className={!isMobile ? classes.languageSwitchContainer : null}>
        <LanguageSwitch />
      </div>
      {isMobile && (
        <>
          <IconButton
            aria-label="menu"
            onClick={handleOpenMenu}
            className={isMobile ? classes.menuIcon : null}
          >
            <MenuIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={menuVisible} onClose={handleCloseMenu}>
            <Toolbar vertical={true} loadEnabled={true} onMenuButtonClicked={handleCloseMenu} />
          </Menu>
        </>
      )}
      <AdditionalInfoDialog
        title={itemTitle}
        isOpen={isAdditionalInfoPopupOpen}
        itemDescription={itemDescription}
        itemPrice={itemPrice}
        onCancel={() => setIsAdditionalInfoPopupOpen(false)}
        onButtonClick={() => setIsAdditionalInfoPopupOpen(false)}
      />
    </div>
  );
};

export default Header;
